import * as actions from 'actions';
import textEditingMaker from 'reducersMakers/textEditingMaker';

export default textEditingMaker({
  submitType: actions.COMMENT_CREATE,
  submitSuccessType: actions.COMMENT_CREATE_SUCCESS,
  submitErrorType: actions.COMMENT_CREATE_ERROR,
  updateTextType: actions.COMMENT_UPDATE_TEXT,
  expandType: actions.COMMENT_EXPAND,
  resetType: actions.COMMENT_RESET
});



/** WEBPACK FOOTER **
 ** ./src/members/state/comments/textEditing/secondLevel/reducer.js
 **/